import axios from 'axios';

let manifestPromise;
const manifestUrl = window.location.origin + '/build/main/js/manifest.json';

export default function getBundleUrl(bundleKey) {
  if (!manifestPromise) {
    manifestPromise = axios.get(manifestUrl);
  }

  return manifestPromise.then(({ data }) => data[bundleKey]);
}
